var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 7.99963C12.2981 7.99963 12.0001 8.2983 12.0001 8.6663V13.9997C12.0001 14.367 11.7014 14.6663 11.3334 14.6663H2.00001C1.63201 14.6663 1.33334 14.367 1.33334 13.9997V4.66627C1.33334 4.29894 1.63201 3.9996 2.00001 3.9996H7.33338C7.70205 3.9996 8.00005 3.70093 8.00005 3.33293C8.00005 2.96493 7.70205 2.66626 7.33338 2.66626H2.00001C0.897339 2.66626 0 3.5636 0 4.66627V13.9997C0 15.1023 0.897339 15.9997 2.00001 15.9997H11.3334C12.4361 15.9997 13.3334 15.1023 13.3334 13.9997V8.6663C13.3334 8.29763 13.0354 7.99963 12.6668 7.99963Z",
    fill: "#C0C0C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25106 7.39238C6.20439 7.43904 6.17306 7.49838 6.15972 7.56238L5.68839 9.91973C5.66639 10.0291 5.70105 10.1417 5.77972 10.2211C5.84305 10.2844 5.92839 10.3184 6.01572 10.3184C6.03706 10.3184 6.05906 10.3164 6.08106 10.3117L8.43774 9.84039C8.50307 9.82706 8.56241 9.79573 8.60841 9.74906L13.8831 4.47436L11.5264 2.11768L6.25106 7.39238Z",
    fill: "#C0C0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5124 0.487503C14.8624 -0.162501 13.805 -0.162501 13.1557 0.487503L12.233 1.41018L14.5897 3.76686L15.5124 2.84419C15.8271 2.53018 16.0004 2.11151 16.0004 1.66618C16.0004 1.22084 15.8271 0.802172 15.5124 0.487503Z",
    fill: "#C0C0C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.94ac52eec24f6b06174e0c66a4640012.svg";
export { ForwardRef as ReactComponent };